/**
 * @override King Living: Header 1.0 / column-by-id default — links only.
 * Do not query menuImageGallery here: master (UK staging) 400s the whole column.
 * Header 2.0 L3 gallery lives on FullMenuItemFragment only.
 */

import gql from 'graphql-tag';

import {BaseNavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column/base-navigation-column.fragment';
import {BaseLinkFragment} from '@amblique/king-living/app/contentful/fragments/link/base-link.fragment';

export const NavigationColumnFragment = gql`
  ${BaseLinkFragment}
  ${BaseNavigationColumnFragment}

  fragment NavigationColumnFragment on NavigationColumn {
    ...BaseNavigationColumnFragment

    linksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    linksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
